import React from 'react'
import nochatview from "../../assets/icons/No-Chat.svg";

export default function EmptyChat() {
  return (
    <div className="empty-conversation-chat">
        <img src={nochatview} alt="no-chat-view" style={{ height: "5rem" }} />
        <div className="no-messages-text">
          No messages yet. Start chatting with the candidate.
        </div>
      </div>
  )
}
